// Z.ai (Zhipu) mark for the GLM models — a bold "Z" on the same 16px white tile the other icons use.
export default function ZaiIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="16"
        height="16"
        rx="2"
        fill="white"
      />
      <path
        d="M3.2 3.2H12.8V4.9L6.4 11.1H12.8V12.8H3.2V11.1L9.6 4.9H3.2V3.2Z"
        fill="black"
      />
    </svg>
  );
}
